import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FurnitureService } from '../api/furniture.service';
import { Router } from '@angular/router';
import { FurnitureItem } from 'src/app/entity/furnitureItem';

@Component({
  selector: 'app-furniture',
  templateUrl: './furniture.component.html',
  styleUrls: ['./furniture.component.scss'],
})
export class FurnitureComponent {
  FurnitureForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private furnitureService: FurnitureService,
    private router: Router
  ) {
    this.FurnitureForm = fb.group({
      XmlText: ['', [Validators.required]],
    });
  }
}
